<template>
  <div class="app" :class="{ darkMode: darkMode }">
    <button style="color: white; background: #8e67c7; border: none" v-if="username == 'amd_india'"
      @click="toggleDarkMode" class="darkmodebutton">
      Dark Mode
    </button>
    <div v-if="!floatingNav" class="containerOverflowClass">
      <div :class="{
        'body-wrapper-open': isSidebarOpen && !showFullBody,
        'body-wrapper-close': !isSidebarOpen,
        'sidebar-open': isSidebarOpen && showFullBody,
      }">
        <div class="sidebar-container">
          <CustomSidebar :menuItems="nav" :isSidebarOpen="isSidebarOpen" @toggle-sidebar="toggleSidebar"
            @close-sidebar="closeSidebar" @open-sidebar="openSidebar" />
        </div>
        <div class="main-container">
          <CustomHeader />
          <main>
            <router-view></router-view>
          </main>
        </div>
      </div>
    </div>
    <div v-else-if="floatingNav">
      <div :class="isSidebarOpen ? 'floatingSidebarOpen' : 'flotingSidebarClose'" id="sidebar">
        <CustomSidebar :menuItems="nav" :isSidebarOpen="isSidebarOpen" @toggle-sidebar="toggleSidebar" />
      </div>
      <div id="content" @touchstart="handleSidebarClose($event)">
        <CustomHeader @open-sidebar="openSidebar" />
        <div>
          <router-view />
        </div>
      </div>
    </div>
    <div v-else>
      <DefaultHeader />
      <div class="app-body">
        <AppSidebar fixed>
          <SidebarHeader />
          <SidebarForm />
          <SidebarNav :navItems="nav"></SidebarNav>
          <SidebarFooter />
          <SidebarMinimizer />
        </AppSidebar>
        <main class="main">
          <!-- <Breadcrumb :list="list"/> -->

          <router-view></router-view>
        </main>
        <AppAside fixed>
          aside
          <!-- <DefaultAside/> -->
        </AppAside>
      </div>
      <DefaultFooter />
    </div>
  </div>
</template>

<script>
import {
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import DefaultHeader from "./DefaultHeader";
import DefaultFooter from "./DefaultFooter";
import CustomSidebar from "./CustomSidebar.vue";
import CustomHeader from "./CustomHeader.vue";

export default {
  name: "DefaultContainer",
  components: {
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader,
    CustomSidebar,
    CustomHeader,
    CustomSidebar,
    CustomHeader
  },
  data() {
    return {
      nav: JSON.parse(localStorage.vocSidebar),
      darkMode: false,
      username: JSON.parse(localStorage.reviewUserData).data.username,
      isSidebarOpen: '',
      localSidebarStatus: '',
      client: JSON.parse(localStorage.reviewUserData).data.client,
      loginData: JSON.parse(localStorage.reviewUserData).data.is_demo,
      showFullBody: false
    };
  },


  created() {
    if (localStorage.voc_darkMode == "true") this.darkMode = true;
    else this.darkMode = false;

    if (localStorage.isSideBar == "true") {
      this.isSidebarOpen = true
      this.localSidebarStatus = true
    } else {
      this.isSidebarOpen = false
      this.localSidebarStatus = false
    };
  },
  mounted() {
    if (this.floatingNav) {
      this.isSidebarOpen = false
    }
  },
  methods: {
    toggleDarkMode() {
      if (this.darkMode == true) localStorage.voc_darkMode = false;
      else localStorage.voc_darkMode = true;
      window.location.reload();
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      localStorage.isSideBar = this.isSidebarOpen;
      this.localSidebarStatus = !this.localSidebarStatus;
      this.showFullBody = false;
    },
    openSidebar() {
      if (!this.localSidebarStatus) {
        this.showFullBody = true;
        this.isSidebarOpen = true;
      }
    },
    closeSidebar() {
      if (!this.localSidebarStatus) {
        this.showFullBody = true;
        this.isSidebarOpen = false;
      }
    },

    handleSidebarClose(event) {
      const sidebar = document.getElementById('sidebar'); // Reference to the sidebar element
      const content = document.getElementById('content'); // Reference to the content element

      const sidebarRect = sidebar.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();

      const touch = event.touches[0]; // Get the first touch event

      // Check if the touch position is within the sidebar boundaries
      if (
        touch.clientX >= sidebarRect.left &&
        touch.clientX <= sidebarRect.right &&
        touch.clientY >= sidebarRect.top &&
        touch.clientY <= sidebarRect.bottom
      ) {
        this.isSidebarOpen = true;
      } else {
        this.isSidebarOpen = false;
      }
    },
  },

  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    },
    floatingNav() {
      if (window.screen.width < 1024) {
        return true;
      } else return;
    }
  },
  watch: {
    isSidebarOpen() {
      if (this.floatingNav) {
        if (this.isSidebarOpen) {
          document.querySelector('body').style.overflow = 'hidden';
        } else if (!this.isSidebarOpen) {
          document.querySelector('body').style.overflow = '';
        }
      }
    }
  }
};
</script>
<style lang="scss">
.body-wrapper-open {
  display: grid;
  grid-template-columns: 15% 85%;
  justify-content: space-between;
}

.body-wrapper-close {
  display: grid;
  grid-template-columns: 5% 94%;
  justify-content: space-between;
}

.sidebar-open {
  display: block;

  .sidebar-container {
    width: 15%;
  }

  .main-container {
    width: 94%;
    float: right;
  }
}

.containerOverflowClass {
  width: 100%;
  overflow-x: hidden;
}

@media screen and (max-width: 675px) {
  .sideBarOpen {
    width: 60% !important;
  }

  .sideBarClose {
    width: 15% !important;
  }

  .bodyOpen {
    width: 100% !important;
    height: 100%;
    min-height: 500px;
  }

  .bodyClose {
    width: 84.4% !important;
    height: 100%;
    min-height: 500px;
  }
}


@media (min-width:676px) and (max-width: 897px) {
  .sideBarOpen {
    width: 35% !important;
  }

  .sideBarClose {
    width: 12% !important;
  }

  .bodyOpen {
    width: 100% !important;
    height: 100%;
    min-height: 500px;
  }

  .bodyClose {
    width: 87.4% !important;
    height: 100%;
    min-height: 500px;
  }
}


@media (min-width:898px) and (max-width:1033px) {
  .sideBarOpen {
    width: 25% !important;
  }

  .sideBarClose {
    width: 8% !important;
  }

  .bodyOpen {
    width: 100% !important;
    height: 100%;
    min-height: 500px;
  }

  .bodyClose {
    width: 91.4% !important;
    height: 100%;
    min-height: 500px;
  }
}

@media (min-width: 1034px) and (max-width: 1199px) {
  .body-wrapper-open {
    display: grid;
    grid-template-columns: 20% 80%;
    justify-content: space-between;
  }

  .body-wrapper-close {
    display: grid;
    grid-template-columns: 7% 92.4%;
    justify-content: space-between;
  }

  .sidebar-open {
    display: block;

    .sidebar-container {
      width: 20%;
    }

    .main-container {
      width: 92.4%;
      float: right;
    }
  }
}

@media (min-width:1200px) and (max-width: 1499px) {
  .body-wrapper-open {
    display: grid;
    grid-template-columns: 20% 80%;
    justify-content: space-between;
  }

  .body-wrapper-close {
    display: grid;
    grid-template-columns: 7% 92.4%;
    justify-content: space-between;
  }

  .sidebar-open {
    display: block;

    .sidebar-container {
      width: 20%;
    }

    .main-container {
      width: 92.4%;
      float: right;
    }
  }
}

@media (min-width: 1500px) and (max-width: 1999px) {
  .body-wrapper-open {
    display: grid;
    grid-template-columns: 15% 85%;
    justify-content: space-between;
  }

  .body-wrapper-close {
    display: grid;
    grid-template-columns: 6% 93.4%;
    justify-content: space-between;
  }

  .sidebar-open {
    display: block;

    .sidebar-container {
      width: 15%;
    }

    .main-container {
      width: 93.4%;
      float: right;
    }
  }
}

@media (min-width: 2000px) and (max-width: 2499px) {
  .body-wrapper-open {
    display: grid;
    grid-template-columns: 15% 85%;
    justify-content: space-between;
  }

  .body-wrapper-close {
    display: grid;
    grid-template-columns: 7% 92.4%;
    justify-content: space-between;
  }

  .sidebar-open {
    display: block;

    .sidebar-container {
      width: 15%;
    }

    .main-container {
      width: 92.4%;
      float: right;
    }
  }
}

@media (min-width: 2500px) {
  .body-wrapper-open {
    display: grid;
    grid-template-columns: 15% 85%;
    justify-content: space-between;
  }

  .body-wrapper-close {
    display: grid;
    grid-template-columns: 6% 93.4%;
    justify-content: space-between;
  }

  .sidebar-open {
    display: block;

    .sidebar-container {
      width: 15%;
    }

    .main-container {
      width: 93.4%;
      float: right;
    }
  }
}
</style>
